import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.el = m.el;
    }
    init() {
        const accordions = [...this.el.querySelectorAll('[data-accordion="accordion"]')];
        accordions.forEach(accordion => {
            accordion.addEventListener('click', () => this.toggleAccordion(accordion));
        });
    }
    toggleAccordion(accordion) {
        accordion.classList.toggle('active-accordion');
    }
}
